<template lang="pug">
  b-container.content-wrap(fluid :class="{ 'is-mobile': isMobile }")
    b-container.d-flex.justify-content-between(fluid)
      .title
        span.page-title {{$t('user')}} {{$t('login')}} {{$t('history')}}

    b-row.search-form
      b-col.mmb-10(cols="6" lg="2")
        b-form-datepicker(
          v-model="range.start"
          :bootstrap-styling="true"
          :language="range.lang"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="search"
        )
      b-col.mmb-10(cols="6" lg="2")
        b-form-datepicker(
          v-model="range.end"
          :bootstrap-styling="true"
          :language="range.lang"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="search"
        )
      b-col.mmb-10(cols="12" lg="5")
        b-input-group
          b-input-group-prepend
            b-form-select.mr-2(v-model="form.selected" :options="selectOptions.list" size="sm" @change="changeSearchSelect")
          b-form-input(v-if="selectInput.type === 'keyword'" size="sm" v-model="form.value" @keypress.enter="search")
          b-form-select.mr-2(v-if="selectInput.type === 'select'" v-model="form.value" :options="selectInput.list" size="sm")
          b-input-group-append
            b-btn(size="sm" @click="search") {{$t('search')}}

      b-col.right-btns
        //- b-btn.ml-2.view-mode-button(size="sm" target="_blank" href="https://linkmemine.co.kr/faq/p/manager_guide_topic_07.php")
        b-btn.ml-2.view-mode-button(size="sm", :disabled="excelLoaded" @click="downloadExcel")
          img.mr-1(:src="`${AppState.Path.image}/icons/excel-icon.svg`" style="height: 0.9rem; vertical-align: middle;")
          span(v-if="!excelLoaded") {{$t('excel_button')}}
          span(v-else) Download...
    
    b-card.table-card
      b-table(
        ref="dataTable",
        :fields="dynamicFields",
        :items="items",
        :current-page="page.current",
        :per-page="page.per",
        :show-empty="true",
        tbody-class="lmm-table-body",
        :empty-text="$t('no-content')"
        sort-by="login_time"
        :sort-desc="true"
        responsive
      )
        template(slot="table-colgroup")
          col(style="width: 20%; max-width: 25%")
        template(slot="HEAD_mgrid", slot-scope="data")
          | {{$t('ID')}}
        template(slot="HEAD_mgr_ip", slot-scope="data")
          | {{$t('user')}} IP
        template(slot="HEAD_login_time", slot-scope="data")
          | {{$t('login_time')}}
        template(slot="HEAD_browser", slot-scope="data")
          | {{$t('browser')}}/{{$t('CS_manager')}}
        template(v-slot:cell(login_time)="row")
          | {{row.item.login_time | moment('YY-MM-DD HH:mm')}}

        template(v-slot:cell(user_type)="row")
          span.member-type-icon(v-if="row.item.user_type === 2 || row.item.user_type === 3") S
          span.member-type-icon(v-if="row.item.user_type === 6") A
        
        template(v-slot:cell(mgrid)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.user_fk}}") {{row.item.mgrid}}
        
        template(v-slot:cell(name)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.user_fk}}") {{row.item.name}}

        template(v-slot:cell(mgr_ip)="row")
          span {{row.item.mgr_pub_ip}}
          span ({{row.item.mgr_pri_ip}})
        template(v-slot:cell(login_from)="row")
          icon(:name="getOS(row.item.login_from)")
        
        template(v-slot:cell(network_type)="row")
          | {{networkType(row.item.network_type)}}
        
        template(v-slot:cell(browser)="row")
          | {{row.item.browser || 'CS'}}
    //- pagination
    .pagination-wrap
      div
        b-form-select(
          size="sm"
          v-model="page.per"
          :options="page.perOptions"
        )
      b-pagination(
        size="sm"
        v-model="page.current"
        :total-rows="page.total"
        :per-page="page.per"
        class="my-0 float-right"
      )
</template>

<script>
import _ from "lodash"
import moment from "moment"
import { getCurrentLanguage } from "@/i18n"
import * as datePickerLocale from "vuejs-datepicker/dist/locale"
import Datepicker from "vuejs-datepicker"
import { AnalysticAPI, GetMgridAPI } from "../../api"
import store from '@/api/store'

export default {
  name: "log-access-component",
  components: { Datepicker },
  computed: {
    selectInput() {
      return _.find(this.selectOptions.list, { value: this.form.selected })
    },
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
    accountType() {
      return store.get('auth').account_type
    },
    dynamicFields() {
      // 기본 필드
      const baseFields = [
        { key: "user_type", label: this.$t('admin_privileges'), sortable: true, thStyle: { minWidth: "120px" } },
        { key: "mgrid", label: this.$t('ID'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
        { key: "name", label: this.$t('account-manage'), sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
        { key: "login_time", label: this.$t('statistics_page.connection_datetime'), sortable: true, thStyle: { minWidth: "130px" }, tdClass: "text-nowrap" },
        { key: "network_type", label: this.$t('statistics_page.connection_environment'), sortable: true, thStyle: { minWidth: "100px" }, tdClass: "text-nowrap" },
      ]
      
      // accountType이 1일 때 추가될 필드
      if (this.accountType === 1) {
        baseFields.push(
            { key: "manager", label: `${this.$t('manager_str')} ${this.$t('name')}`, sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
            { key: "os", label: `${this.$t('manager_str')} OS`, sortable: true, thStyle: { minWidth: "120px" }, tdClass: "text-nowrap" },
        )
      }
      
      return baseFields
    },
    networkType() {
      return (value) => {
        switch (value) {
          case 0:
            return this.$t('internal')
          case 1:
            return this.$t('external')
          case 2:
            return this.$t('statistics_page.development_environment')
          default:
            return "-"
        }
      }
    },
  },
  methods: {
    items(ctx) {
      if (ctx.sortBy === "") return

      this.page.by = ctx.sortBy
      this.page.per = ctx.perPage
      this.page.order = ctx.sortDesc ? "desc" : "asc"
      this.page.offset = (this.page.current - 1) * this.page.per

      let params = {
        by: this.page.by,
        limit: this.page.per,
        offset: this.page.offset,
        order: this.page.order,

        start_date: this.page.start_date,
        end_date: this.page.end_date,

        search_key: this.page.search_key,
        search_value: this.page.search_value,
        search_mode: "pagination",
        export_id: "accessHistoryTable",
      }
      return AnalysticAPI.history.get("access", { params }).then(res => {
        this.page.total = res.data.meta.total_count
        return res.data.objects
      })
    },

    search() {
      this.page.start_date = moment(this.range.start).format("YYYY-MM-DD")
      this.page.end_date = moment(this.range.end).format("YYYY-MM-DD")
      this.page.current = 1
      this.page.search_key = this.form.selected
      this.page.search_value = this.form.value
      this.$refs.dataTable.refresh()
    },
    changeSearchSelect() {
      if (this.selectInput.type === "select") {
        this.form.value = this.selectInput.list[0].value
      } else {
        this.form.value = ""
      }
    },

    async downloadExcel() {
      this.excelLoaded = true
      const params = await this.fetchExcel()
        .then(params => {
          //전송용 임시 폼 엘리먼트 생성
          var form = document.createElement("form")
          form.method = "post"
          form.action = "/download/excel.html" // /download/excel.html을 통해 DownloadExcelFileAPI호출

          // 엑셀 생성에 필요한 필터된 데이터를 폼에 추가
          let jsonData = {...params, language: this.$i18n.locale}
          var input = document.createElement("input")
          input.type = "hidden"
          input.name = "jsondata"
          input.value = JSON.stringify(jsonData)
          form.appendChild(input)

          // body에 폼 추가 및 제출 그 후 제거
          document.body.appendChild(form)
          form.target = "_blank"
          form.submit()
          document.body.removeChild(form)

          this.excelLoaded = false
        })
        .catch(err => {
          this.excelLoaded = false
          alert(this.$t('toasts_message.no_data_to_download_excel'))
          return
        })
    },

    async fetchExcel() {
      let params = {
        by: this.page.by,
        limit: 0,
        offset: 0,
        order: this.page.order,

        start_date: moment(this.range.start).format("YYYY-MM-DD"),
        end_date: moment(this.range.end).format("YYYY-MM-DD"),

        search_key: this.page.search_key,
        search_value: this.page.search_value,
        search_mode: "pagination",
        export_id: "accessHistoryTable",
      }

      if (this.page.total < 1) {
        throw new Error(this.$t('no_data_available'))
      }
      const list = await AnalysticAPI.history.get("access", { params })

      const excelParams = list.data
      excelParams.excel_doc_title = this.$t('statistics_page.user_login_history')

      const { data } = await GetMgridAPI.get("")
      const excelParams_for_download = {
        api: excelParams.api,
        excel_doc_title: "",
        pagename: "",
        mgrid: data.objects.mgrid,
        objects: this.downloaded_excel_data_form(excelParams.objects),
      }
      excelParams_for_download.pagename = "log_access"
      excelParams_for_download.excel_doc_title = this.$t('statistics_page.user_login_history')

      return excelParams_for_download
    },
    downloaded_excel_data_form(input) {
      let originalLocale = this.$i18n.locale
      this.$i18n.locale = "ko"
      
      //input = excelParams.objects
      let user_type = {
        "1": this.$t('user'),
        "2": this.$t('policy_manager'),
        "3": this.$t('policy_manager'),
        "6": this.$t('mid_manager'),
      }
      let network_type = {
        "0": this.$t('statistics_page.internal_network'),
        "1": this.$t('statistics_page.external_network'),
        "2": this.$t('statistics_page.development_environment'),
      }
      let output = []
      for (let index = 0; index < input.length; index++) {
        let obj = {
          [this.$t('admin_privileges')]: user_type[input[index]["user_type"]],
          [this.$t('ID')]: input[index]["mgrid"],
          [this.$t('account-manage')]: input[index]["name"],
          [this.$t('statistics_page.login_date')]: this.Date_time_split(input[index]["login_time"])[0],
          [this.$t('statistics_page.login_time')]: this.Date_time_split(input[index]["login_time"])[1],
          [this.$t('manager_str')]: input[index]["manager"],
          OS: input[index]["os"],
          [this.$t('statistics_page.connection_environment')]: network_type[input[index]["network_type"]],
        }
        let obj2 = Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, this.nullcheck(value)]))
        output.push(obj2)
      }
      this.$i18n.locale = originalLocale
      return output
    },
    nullcheck(input) {
      return input == null ? "-" : input
    },
    Date_time_split(input) {
      let return_array = []
      if (input != "-") {
        let input_array = input.split(" ")
        return_array[0] = input_array[0]
        return_array[1] = input_array[1]
          .split(":")
          .slice(0, 2)
          .join(":")
      } else {
        return_array[0] = "-"
        return_array[1] = "-"
      }
      return return_array
    },
    // keyChangeHandler() {
    //   this.filter.value = ""
    // },
    startDateChanged(date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged(date) {
      this.range.end = date
    },
    tableRefresh() {
      this.page.current = 1
      this.$refs.dataTable.refresh()
    },
    getOS(id) {
      switch (id) {
        case 1:
          return "windows"
        default:
          return "windows"
      }
    },
  },
  data() {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      excelLoaded: false,
      excelLink: null,
      range: {
        start: moment()
          .add(-14, "days")
          .toDate(),
        end: moment().toDate(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()],
      },
      form: {
        selected: "mgrid",
        value: "",
      },
      selectOptions: {
        list: [
          {
            text: this.$t('admin_privileges'),
            value: "user_type",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: this.$t('policy_manager'), value: "3" },
              { text: this.$t('mid_manager'), value: "6" },
              { text: this.$t('user'), value: "1" },
            ],
          },
          { text: this.$t('ID'), value: "mgrid", type: "keyword" },
          { text: this.$t('account-manage'), value: "name", type: "keyword" },
          { text: `${this.$t('manager_str')} ${this.$t('name')}`, value: "manager", type: "keyword" },
          // { text: "매니저IP", value: "ip", type: "keyword" },
          // { text: "브라우저", value: "browser", type: "keyword" },
          {
            text: `${this.$t('manager_str')} OS`,
            value: "os",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              // { text: "UNKNOWN", value: "0" },
              { text: "Windows", value: "1" },
              // { text: "Linux", value: "2" },
              // { text: "OS_X", value: "3" },
              { text: "Android", value: "4" },
              // { text: "iOS", value: "5" },
            ],
          },
          {
            text: this.$t('statistics_page.connection_environment'),
            value: "network_type",
            type: "select",
            list: [
              { text: this.$t('total'), value: "" },
              { text: this.$t('statistics_page.internal_network'), value: "0" },
              { text: this.$t('statistics_page.external_network'), value: "1" },
            ],
          },
        ],
      },
      page: {
        by: "login_time",
        order: "desc",
        total: 0,
        current: 1,
        per: 24,
        offset: 0,
        start_date: moment()
          .add(-14, "days")
          .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        search_key: "",
        search_value: "",

        perOptions: [
          { value: 12, text: "12" },
          { value: 24, text: "24" },
          { value: 36, text: "36" },
        ],
      },
      filter: {
        key: "e-mail",
        value: "",
        options: [
          { text: this.$t("ID"), value: "e-mail" },
          { text: this.$t("browser"), value: "browser" },
        ],
        osOptions: [
          { text: this.$t("please_select"), value: "" },
          { text: this.$t("windows"), value: 1 },
          { text: this.$t("linux"), value: 2 },
          { text: this.$t("mac"), value: 3 },
          { text: this.$t("android"), value: 4 },
          { text: this.$t("ios"), value: 5 },
        ],
      },
    }
  },
}
</script>

<style lang="scss" scoped>
// .lmm-content-body-padded {
//   padding: 0;
//   margin: 0;
// }

// .row, .col, .container-fluid, .container {
//   margin: 0;
//   padding: 0;
// }

// .page-wrap {
//   padding: 1rem 1.5rem;
// }

// .page-header {
//   padding: 0 1.5rem 0 1.5rem;
//   margin-bottom: 0.5rem;
// }

// .card {
//   border-radius: 0;
//   .card-body {
//     padding: 0;
//   }
// }

// ::v-deep .b-table {
//   margin: 0;
//   table-layout: fixed;
//   width: 100%;
//   tr, td, th {
//     padding: 0.5rem 0 0.5rem 1rem;
//     position: relative;
//     font-weight: 400;
//   }
//   th:nth-child(1), th:nth-child(2), th:nth-child(3), th:nth-child(4) {
//     position: relative;
//     padding-right: 0;
//     text-align: left !important;
//   }
//   th:nth-child(1), td:nth-child(1) {
//     padding-left: 1rem;
//   }
//   td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4) {
//     position: relative;
//     padding-right: 0;
//     text-align: left !important;
//     color: #6F6F6F;
//   }
// }

// ::v-deep .form-control, .custom-select {
//   display: flex;
//   background-color: #FFFFFF !important;
//   border: 1px solid #6F6F6F !important;
//   border-radius: 0;
//   height: 1.75rem;
//   align-items: center;
//   text-align: left !important;
// }
</style>
